import { Component } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { Abrangencia } from '../entity/abrangencia.model';
import { BaseListComponent } from "../base/base-list.component";
import { Situacoes } from 'app/entity/enumeraveis';

@Component({
    selector: 'evento-prestacao-conta',
    templateUrl: './evento-prestacao-conta.component.html',
})
export class EventoPrestacaoContaComponent extends BaseListComponent {
    controllerName = 'edicaoEvento';
    filtro = this.formBuilder.group({
        query:[null],
        id_evento:[null]
    });
    dataDia:Date = new Date();

    evento: any = null;
    listaEdicao: any[] = [];
    idEvento:number = null;
    linkSelecionado:string;
    namePrestarConta:string;
    nameEditar:string;
    nameVisualizar:string;
    algo:any;
    query: string;
    private situacoesMap: { [id: number]: string } = {};
    
    init(){
        this.buildSituacoesMap();

        if (sessionStorage.getItem("msg") != null) {
            this.showMsgSucess(sessionStorage.getItem("msg"))
            sessionStorage.removeItem("msg");
        }

        this.listagem.pDatatableComponent.sortOrder = 2;
        var listaLink = location.href.split("/")
        this.linkSelecionado = listaLink[6]
        this.idEvento = +listaLink[7];

        this.filtro.get('id_evento').setValue(this.idEvento);
        if(this.linkSelecionado === 'listar-edicao'){
            this.namePrestarConta = 'edicao_prestar_conta';
            this.nameEditar = "edicao_editar";
            this.nameVisualizar = 'edicao_visualizar';
        }else{
            this.namePrestarConta = 'edicao_prestar_conta_homologacao';
            this.nameEditar = "edicao_editar_homologacao";
            this.nameVisualizar = 'edicao_visualizar_homologacao';
        }
        
        if(sessionStorage.getItem('turma_edicao') == this.router.url.split('/')[2]){
            this.query = sessionStorage.getItem('filtro_turma_edicao');
            this.algo = this.query.split('&')
            .map(str => {
                let [key, value] = str.split('=');
                return {[key]: decodeURI(value)};
            })
            .reduce((prev, curr) => Object.assign(prev, curr));
            Object.keys(this.algo).forEach(key => {
                this.algo[key] = this.algo[key].split('%2C').length > 1 ? this.algo[key].split('%2C') : this.algo[key];
                if(!Array.isArray(this.algo[key])){
                  this.algo[key] = this.algo[key].split('+').length > 1 ? this.concatStringFiltro(this.algo[key].split('+')) : this.algo[key];
                }
                this.algo[key] = this.algo[key] == "null" ? null : this.algo[key];
            });
            this.filtro.patchValue(this.algo);
            this.carregarEstadoPaginacao();
        }else if(sessionStorage.getItem('funcionalidade') != 'gerenciamento-evento' && sessionStorage.getItem('funcionalidade') != 'homologacao-evento'){
            sessionStorage.removeItem('funcionalidade');
            sessionStorage.removeItem('filtro');
            sessionStorage.removeItem('pagina');
        }
    }
    voltar(event: any){
        if(this.linkSelecionado === 'listar-edicao'){
            this.router.navigate(['/atividades/gerenciamento-evento'], { relativeTo: this.activatedRoute });
        }else{
            this.router.navigate(['/atividades/homologacao-evento'], { relativeTo: this.activatedRoute });
        }
    }

    private buildSituacoesMap(): void {
        for (const key in Situacoes) {
          const valor = (Situacoes as any)[key];
          if (typeof valor === 'number') {
            this.situacoesMap[valor] = key;
          }
        }
      }

      getSituacaoNome(obj: { id_situacao: number; data_exclusao: any }): string {
        if (obj.data_exclusao !== null && obj.data_exclusao !== undefined) {
          return this.situacoesMap[26] || 'Excluído pelo usuário';
        }
        return this.situacoesMap[obj.id_situacao] || 'Desconhecido';
      }
}


// WEBPACK FOOTER //
// ./src/app/evento-prestacao-conta/evento-prestacao-conta.component.ts